export default {
	termsAndConditions: {
		lastUpdate: 'Sidst opdateret: 10. juni 2024',
		content: `
		<p>Vilkårene, du finder nedenfor, er vigtige, fordi:</p>
		<ul>
			<li>De etablerer deres juridiske rettigheder i {siteName}.</li>
			<li>Forklar de rettigheder, du giver os, når du bruger {siteName}.</li>
			<li>
				De beskriver de regler, som alle skal respektere, når de bruger {siteName}.
			</li>
		</ul>
		<p>
			Læs venligst disse vilkår omhyggeligt såvel som vores {privacyPolicyLink} og andre
			dokumenter nævnt i disse vilkår.
		</p>
		<p>Lad os komme i gang...</p>
		<h3>1. INTRODUKTION OG DATA FOR {siteNameUpper}.</h3>
		<p>
			Hjemmesiden {websiteLink} (herefter "hjemmesiden") ejes af virksomheden
			{siteName} S.L (herefter "{siteName}"), en virksomhed
			indarbejdet i overensstemmelse med spansk lovgivning med adresse på Avenida de
			Cerdanyola, nº 75, 1º, Sant Cugat del Vallès (Barcelona), indehaver af CIF-nummer
			B-56.768.260 og registreret i Mercantile Registry of Barcelona i bind
			49065, Folio 0033, Blad B-606324, 1. registrering.
		</p>
		<p>
			{siteName} stiller webstedet til din rådighed, så du kan komme til
			kend os bedre, kend de services vi leverer og hvis du ønsker det, kan du kontakte
			og, hvor det er relevant, kontrakt med os.
		</p>
		<h3>2. FORMÅL OG ANVENDELSESOMFANG AF BETINGELSERNE FOR BRUG</h3>
		<p>
			Disse brugsbetingelser udgør sammen med {privacyPolicyLink} og
			{cookiesPolicyLink}, den juridiske ramme, der regulerer brugen af hjemmesiden
			{websiteLink}. Disse brugsbetingelser vil være tilgængelige for dig på hjemmesiden
			på engelsk, så du til enhver tid kan konsultere, arkivere eller udskrive dem
			når du ønsker.
		</p>
		<p>
			For at få ethvert spørgsmål vedrørende behandlingen udført af {siteName}.
			af dine personlige data, bedes du besøge vores {privacyPolicyLink} og vores {cookiesPolicyLink}.
			Begge politikker vil også være tilgængelige for dig på engelsk, så du kan
			konsultere, arkivere eller udskrive dem til enhver tid.<br />
			{siteName} bruger tredjepartscookies på webstedet. For at finde ud af mere
			om typen af cookies, der bruges på nettet {websiteLink}, deres formål og hvordan
			for at konfigurere din browser, hvis du ikke ønsker, at vi skal bruge disse cookies,
			besøg venligst vores {cookiesPolicyLink}.
		</p>
		<p>
			Begge disse brugsbetingelser såvel som {privacyPolicyLink} og 
			{cookiesPolicyLink} er blevet udarbejdet i overensstemmelse med bestemmelserne i gældende
			gældende regler, bl.a. lov 34/2002, om tjenesteydelser af
			Informationssamfundet og elektronisk handel og forordning (EU) 2016/679 af
			Europa-Parlamentet og Rådet af 27. april 2016 vedr
			beskyttelse af fysiske personer med hensyn til behandling af personlige
			data og den frie bevægelighed for disse data, og hvorved direktiv 95/46/EF
			er ophævet.
		</p>
		<h3>3. ADGANG TIL WEBSTEDET OG ACCEPT</h3>
		<p>
			Adgang til hjemmesiden er gratis bortset fra den del, der er relateret til omkostningerne ved
			forbindelse gennem det telekommunikationsnetværk, der leveres af internettet
			adgangsudbyder, som du har indgået aftale med. Du kan frit gennemse hjemmesiden
			og få adgang til det så mange gange du vil. For at få adgang til og navigere på webstedet,
			du behøver ikke tilmelde dig, undtagen hvis du ønsker at leje en tjeneste.
		</p>
		<p>
			Brugen af hjemmesiden giver dig tilstanden som bruger af hjemmesiden
			(herefter "Brugeren") og indebærer din fulde og uforbeholdne accept af
			disse brugsbetingelser samt {privacyPolicyLink} og {cookiesPolicyLink}
			af hjemmesiden. Desuden accepterer du ikke at bruge Tjenesten til ulovlig
			formål.
		</p>
		<p>
			Ved at tilgå webstedet og gennemse det, erklærer du under din
			ansvar for, at du er myndig, og at du har de nødvendige juridiske
			kapacitet til at få adgang til webstedet og bruge det, også erklære, at du fuldt ud
			forstå og acceptere disse brugsbetingelser uden forbehold.
		</p>
		<p>
			På den anden side informerer vi dig om, at vi af juridiske årsager arkiverer
			elektroniske dokumenter, hvori indkøbene formaliseres. Du kan få adgang
			disse dokumenter til enhver tid ved at anmode om det på: {supportLink}.
		</p>
		<h3>4. BETINGELSER FOR BRUG AF WEBSTEDET</h3>
		<p>
			Brugeren accepterer at bruge hjemmesiden i overensstemmelse med disse brugsbetingelser,
			gældende lovgivning og god tro. Således vil brugeren svare på {siteName}.
			 og over for enhver tredjepart for de skader og tab, der er afledt af
			brugen i strid med disse betingelser, lovgivningen og den foretagne gode tro
			af brugeren af hjemmesiden.
		</p>
		<h3>5. BESKRIVELSE AF TJENESTEN</h3>
		<p>
			Gennem tjenesten tillader {siteName} abonnement på tjenesten
			udføre billedredigering.
		</p>
		<p>
			Det sprog, hvorpå kontrakten mellem {siteName} og køberen
			vil blive konkluderet, vil være oprindelseslandets.<br />
			Købsprocessen i onlinetjenesten vil være som følger:
		</p>
		<ol>
			<li>Du skal registrere dig på webstedet med et brugernavn og en adgangskode.</li>
			<li>
				På tidspunktet for registreringen skal brugeren vælge en af betalingsplanerne
				findes i afsnittet Priser og vil blive tildelt kreditter afhængigt af
				valgt plan. Hver kredit giver dig mulighed for at redigere ét billede.
			</li>
			<li>
				Efter købet af tjenesten vil brugeren have en administration
				panel, hvor de finder:
				<ul>
					<li>
						En sektion med en liste over alle de billeder, der er blevet behandlet, er
						i stand til at redigere det så mange gange du vil og downloade det til din
						enhed.
					</li>
					<li>
						Et afsnit af Planer og betalinger for at konsultere fakturaerne og annullere
						abonnement.
					</li>
					<li>En sektion af Min konto for at kunne ændre kontopræferencer.</li>
				</ul>
			</li>
		</ol>
		<p>
			Når købet af tjenesten er foretaget, vil det blive bekræftet af
			at sende en e-mail, inden for en periode på højst 24 timer, til den adresse du har
			angivet. Det vil indikere tjenesten, hvordan man annullerer abonnementet, dens
			beløb, gældende afgifter, betalingsform og de gældende vilkår og
			betingelser.
		</p>
		<h4>5.1 Abonnement</h4>
		<p>
			Serviceabonnementet varierer afhængigt af den valgte plan og vil være
			automatisk fornyet for den samme periode indtil dens ophør.
			Medmindre du opsiger dit abonnement, giver du os tilladelse til at indlæse
			tilsvarende årligt abonnementsgebyr i din betalingsmetode.
		</p>
		<p>
			Du kan til enhver tid opsige dit abonnement på Tjenesten, og det vil du
			fortsat have adgang til det indtil udgangen af din årlige faktureringsperiode. Til
			i det omfang loven tillader det, kan betalinger ikke refunderes, og vi yder ikke
			refusioner eller kreditter for delvise årlige abonnementsperioder.
		</p>
		<h3>6. PRIS OG SKATTER</h3>
		<p>
			Priserne på de produkter, der tilbydes på {siteName}, er angivet i euro
			(€) eller valutaen i det land, hvorfra købet er foretaget, Værdien
			Tillægsafgift (moms), der er gældende på købstidspunktet, opkræves af prisen på
			Produkter.
		</p>
		<p>
			Under alle omstændigheder vil driften kunne være fritaget eller ikke momspligtig afhængig af
			dit bopælsland eller den tilstand, du handler under. Af denne grund,
			i nogle tilfælde kan den endelige pris for ordren blive ændret i forhold til
			en vist.<br />
			Køb foretaget af subjekter fritaget for momsbetaling vil angive dette pr
			sende deres VAT/NIF-nummer via e-mail til {supportLink}, ikke optagelse
			indkøb med nævnte afgift.
		</p>
		<h3>7. BETALINGSMÅDE</h3>
		<p>
			Online betaling af den købte service kan ske med kredit- eller betalingskort.
			I denne forstand informerer {siteName} kredit- og betalingskortindehavere om det
			transaktioner i netbutikken udføres gennem en sikker betaling
			gateway, der bruger SSL-teknologi til at garantere sikkerheden ved datatransmission.
		</p>
		<h3>8. FORTRYDELSESRET OG TILBAGEBETALINGER</h3>
		<h4>8.1. Fortrydelsesret</h4>
		<p>
			Givet den type produkt, der markedsføres i vores onlinetjeneste, software i digital
			format af QR, vil fortrydelsesretten ikke være gældende iflg
			§ 103, litra m), i kgl. lovdekret 1/2007 af 16. november af
			den, at den reviderede tekst til den almindelige lov om forbrugernes forsvar og
			Brugere og andre supplerende love er godkendt.
		</p>
		<h4>8.2. Tilbagebetalinger</h4>
		<p>
			Uanset planen valgt af brugeren, beløbene betalt af brugeren og til
			det omfang, loven tillader, vil ikke blive refunderet.
		</p>
		<p>
			Den aftalte tjeneste må ikke tildeles eller overdrages til andre brugere af
			servicen.
		</p>
		<p>
			Under alle omstændigheder kan brugeren gøre brug af den aftalte tjeneste indtil udgangen af
			den aftalte periode.
		</p>
		<h3>9. GYLDIGHED AF TILBUD</h3>
		<p>
			De tjenester, der tilbydes i Tjenesten, og deres priser, vil være tilgængelige for
			købe, mens de er i kataloget over tjenester, der vises herigennem
			internet side.
		</p>
		<p>
			Under alle omstændigheder forbeholder {siteName} sig retten til at foretage ændringerne
			finder passende i Tjenesten, at være i stand til at opdatere produkter og tjenester
			afhængig af markedet.
		</p>
		<p>
			{siteName} forbeholder sig retten til at ændre priser uden forudgående varsel. Vi
			informere dig om, at på trods af de opdateringer, der er foretaget af priserne på
			Service, de kan indeholde fejl. Vi vil straks rette eventuelle fejl
			vises, men de vil ikke være bindende for Tjenesten.
		</p>
		<h3>10. SIKKERHED</h3>
		<p>
			Som angivet ovenfor, hele købsproceduren, såvel som transmissionen
			af dine persondata og betalingssystemer, udføres på en sikker side og
			på en krypteret måde gennem SSL-protokollen.
		</p>
		<p>
			Vi garanterer Tjenestens sikkerhed i overensstemmelse med gældende
			teknologisk viden. {siteName} kan dog ikke garantere det fulde
			fremtidig sikkerhed for tjenesten. Under alle omstændigheder lover vi at rette og
			implementere passende korrigerende foranstaltninger for at rette op på en eventuel sikkerhed
			brud hurtigst muligt.
		</p>
		<p>
			Du accepterer at give {siteName} besked omgående og via e-mail {supportLink}
			af enhver situation, der kan føre til efterligning af en brugers identitet.
		</p>
		<h3>11. ÆNDRINGER OG NULLITET</h3>
		<p>
			Vi kan også opdatere vilkårene og betingelserne for tjenesten i fremtiden
			som egenskaberne og funktionerne i selve Tjenesten.
		</p>
		<p>
			Vi vil informere dig om ændringerne i vilkår og betingelser ved at placere en meddelelse
			på et fremtrædende sted på vores hjemmeside og/eller via e-mail.
		</p>
		<p>
			Hvis nogen klausul inkluderet i disse vilkår og betingelser er erklæret, helt eller
			delvis, ugyldig eller ineffektiv, vil det kun påvirke nævnte bestemmelse eller delen
			af det, der er ugyldigt eller ineffektivt. Vilkår og betingelser vil bestå i
			alt andet, at have en sådan bestemmelse, eller den del af den, der er berørt af
			ikke bliver placeret.
		</p>
		<h3>12. KRAV OG HANDLINGER AFLEDT AF KONTRAKTEN</h3>
		<p>
			Så vidt muligt er denne tjeneste underlagt spansk lov.<br />
			For at forenkle sagsbehandlingen gennem civile sager og
			reducere omkostningerne, udelukker vi ikke muligheden for at underkaste os en
			Equity Voldgift ved Voldgiftsretten for handelskamrene og
			Industri. I denne forstand og i henhold til gældende regler,
			 {siteName} informerer om eksistensen af en europæisk online tvistbilæggelse
			platform, der letter løsningen af sådanne tvister uden for retten
			kontrakter indgået også online mellem forbrugere og internettjenester
			udbydere. Denne platform kan tilgås via følgende hjemmeside:
			<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
		</p>
		<h3>13. INTELLEKTUELLE OG INDUSTRIELLE EJENDOMSRET</h3>
		<p>
			Hjemmesiden og dens indhold er underlagt beskyttelse i henhold til
			gældende nationale bestemmelser om intellektuel og/eller industriel ejendomsret, som
			samt i anvendelse af de internationale konventioner, der gælder i sådanne
			betyder noget. {siteName} er ejeren eller har behørigt licenseret alle
			Intellektuelle og industrielle ejendomsrettigheder på hjemmesiden og dens indhold.
		</p>
		<p>
			Enhver form for reproduktion, distribution, offentlig kommunikation, transformation,
			tilgængeliggørelse og i almindelighed enhver anden udnyttelseshandling, hvad enten den er eller ej
			til kommercielle formål på webstedet eller dets indhold, uden forudgående
			udtrykkeligt samtykke fra {siteName}. Det er udtrykkeligt forbudt at slette
			identificere data for {siteName} som ejeren af den intellektuelle og
			Industrielle ejendomsrettigheder til webstedet eller dets indhold.
		</p>
		<p>
			{siteName} forbeholder sig alle intellektuelle og industrielle rettigheder
			over hjemmesiden og dens indhold, også forbeholder sig udøvelsen af enhver juridisk
			handlinger, der svarer til det for at standse, forhindre eller retsforfølge evt
			ulovlig brug af hjemmesiden eller dens indhold. I intet tilfælde og under nr
			omstændigheder gør adgang til webstedet eller dets brug af brugeren eller tredjemand
			parter udgør eller antyder en overdragelse af enhver art fra {siteName} af
			de intellektuelle eller industrielle ejendomsrettigheder til webstedet eller dets indhold.
			I intet tilfælde manglen på krav fra {siteName} om at ophøre med brugen af
			Hjemmesiden eller dens ulovlige eller indhold i strid med disse betingelser kan være
			forstået som et stiltiende samtykke fra {siteName} til sådanne anvendelser eller som et frafald
			af udøvelsen af ethvert retsskridt, der måtte svare til det.
		</p>
		<h3>14. ANSVAR OG GARANTIER</h3>
		<p>
			Brugeren skal bruge hjemmesiden og dens indhold i overensstemmelse med
			bestemmelser i disse brugsbetingelser, gældende lovgivning og god tro. Nogen
			brug af hjemmesiden eller dens indhold i strid med disse generelle betingelser
			lov eller god tro er udtrykkeligt forbudt, uanset om den nævnte brug har
			et økonomisk formål eller ej.<br />
			Brugeren er ansvarlig for enhver skade eller skade forårsaget af {siteName}
			 eller til tredjeparter afledt direkte eller indirekte fra enhver brug
			som Brugeren gør af Hjemmesiden eller dens indhold i strid med disse
			forhold, loven, sædelighed, offentlig orden eller god tro.
		</p>
		<p>
			For at webstedet og dets indhold skal være tilgængeligt for brugeren, {siteName}
			 kræver tjenester leveret af tredjeparter. Det er muligt
			på trods af de bestræbelser, som {siteName} har gjort for at holde webstedet tilgængeligt
			og tilgængelig for brugere, kan dens tilgængelighed blive suspenderet, afbrudt eller
			annulleret af årsager ud over {siteName}. Det er derfor {siteName}
			garanterer ikke fraværet af afbrydelser eller fejl i adgangen til
			Hjemmesiden eller dens indhold, ej heller at de er opdateret eller altid vises i
			deres seneste version. Som følge heraf afviser {siteName} enhver
			ansvar for skader, der måtte være afledt til brugeren eller tredjeparter som
			et resultat af afbrydelsen, afbrydelse, manglende kontinuitet, netafbrydelse
			eller afbrydelse af hjemmesiden.
		</p>
		<p>
			I intet tilfælde og under ingen omstændigheder vil {siteName} være ansvarlig for
			skader eller tab afledt af brugeren af årsager, der ikke kan tilskrives {siteName}
			 såsom, som eksempel og i intet tilfælde begrænsende, naturligt
			katastrofer, situationer med force majeure eller ekstrem hastende, vira, skadelige
			komponenter, browserfejl, netværksfald, computerindtrængen el
			tredjepartsangreb.
		</p>
		<h3>15. LINKS</h3>
		<p>
			De websteder, platforme, fora, chats, blogs eller eksterne sociale netværk, der
			link eller link til hjemmesiden skal tydeligt informere om, at de ikke har
			autorisation eller overvågning af {siteName} og det nævnte link eller
			linket indebærer, antager eller antyder ikke tilknytning af nogen art mellem {siteName}
			 og websteder, platforme, fora, chats, blogs eller eksterne
			sociale netværk, der linker eller linker til webstedet.
		</p>
		<p>
			Under alle omstændigheder skal ethvert link, der er bestemt til webstedet, dirigeres
			direkte til hjemmesidens startside eller startside ved at klikke på URL'en
			af hjemmesiden, der dækker hele skærmen på startsiden eller startsiden af
			hjemmesiden, således at linket er absolut og komplet uden brug af
			rammer, rammer eller hyperlinks. {siteName} svarer under ingen omstændigheder
			og under alle omstændigheder til indhold, information eller data relateret til
			webstedet, dets indhold eller andre forhold indeholdt i webstederne, platformene,
			fora, chats, blogs eller tredjeparts sociale netværk, der linker eller linker til
			Internet side.
		</p>
		<p>
			Det er udtrykkeligt forbudt at linke til eller linke til hjemmesiden fra hjemmesider,
			platforme, fora, chats, blogs eller sociale netværk i strid med loven, moral
			og gode skikke, især dem med pornografisk, ulovlig, ulovlig eller
			krænker menneskerettighedsindhold.
		</p>
		<p>
			På den anden side kan hjemmesiden indeholde links til tredjeparts hjemmesider,
			platforme, fora, chats, blogs eller sociale netværk. Det gør {siteName} ikke
			have de menneskelige og/eller tekniske midler til at kende eller kontrollere informationen og
			indhold, der vises på tredjepartswebsteder. Derfor vil {siteName} under ingen omstændigheder
			 være ansvarlig for indholdet af de linkede sider og under nr
			omstændigheder kan nævnte links betragtes som effektiv viden om indholdet
			af de websteder, de linker til.
		</p>
		<h3>16. DATABESKYTTELSE</h3>
		<p>
			Som fastslået i sin {privacyPolicyLink} forpligter {siteName} sig til at bruge Bruger
			data, for at respektere deres fortrolighed og bruge dem i overensstemmelse med
			formålet med behandlingen, samt at overholde sin forpligtelse til at gemme den.
			og tilpasse alle foranstaltninger for at undgå ændring, tab, behandling eller uautoriseret
			adgang i overensstemmelse med gældende lovgivnings bestemmelser vedr
			beskyttelse af personoplysninger.
		</p>
		<p>
			Hjemmesiden inkorporerer passende sikkerhedsforanstaltninger og bruger industristandard
			teknologi til at forbedre sikkerheden, integriteten, fuldstændigheden, nøjagtigheden og
			beskyttelse af de personoplysninger, den har indsamlet og har etableret
			rimelige forholdsregler for at beskytte disse oplysninger mod eventuelt tab eller
			misbruge. Dens regler om databeskyttelse og -sikkerhed revideres med jævne mellemrum
			og forbedres, når det er nødvendigt, og det stræber efter at sikre, at kun autoriseret
			personer kan få adgang til de oplysninger, som brugeren har givet.
		</p>
		<p>
			For at få mere at vide om styring og behandling udført af {siteName}
			 af dine data, bedes du læse vores {privacyPolicyLink} og vores {cookiesPolicyLink}.
		</p>
		<h3>17. VARIGHED OG ÆNDRING</h3>
		<p>
			Disse brugsbetingelser vil være gældende, så længe de udsættes for
			brugere, således at så snart de er helt eller delvist ændret eller opdateret,
			disse betingelser vil ophøre med at være i kraft, da de er de nye brugsbetingelser
			dem, der fortsætter med at regulere brugen af hjemmesiden.
		</p>
		<p>
			{siteName} forbeholder sig retten til at gennemgå, ændre eller opdatere disse
			brugsbetingelser til enhver tid. I tilfælde af enhver ændring af disse betingelser
			af brug uanset årsag, vil {siteName} underrette brugerne på startsiden om
			nettet om nævnte forhold, så de er behørigt informeret og kan konsultere
			revisioner, ændringer eller opdateringer af de nuværende brugsbetingelser til
			din tilfredshed.
		</p>
		<h3>18. GENERELT</h3>
		<p>
			I intet tilfælde og under ingen omstændigheder må den manglende udøvelse af dine rettigheder
			af {siteName} skal forstås som et afkald på dem.
		</p>
		<p>
			Overskrifterne i disse betingelser er kun vejledende eller
			informative, så de ikke påvirker, kvalificerer eller udvider fortolkningen
			deraf.
		</p>
		<p>
			I tilfælde af at nogen af klausulerne i disse betingelser var
			erklæret ugyldig, misbrugende eller uhåndhævelig, helt eller delvist, af en retsinstans
			eller administrativt organ, vil nævnte erklæring individuelt påvirke klausulen
			pågældende, idet man tager det som ikke og uden ugyldighedserklæring, misbrug el
			uanvendelighed udvides under nogen omstændigheder til resten af
			forhold, som vil bestå.
		</p>
		<p>
			Disse brugsbetingelser samt {privacyPolicyLink} og {cookiesPolicyLink}
			er underlagt gældende spanske regler til enhver tid.
		</p>
		<h3>19. KUNDESERVICE</h3>
		<p>
			For enhver afklaring, hændelse eller krav kan du kontakte os via:<br />
			E-mail: {supportLink}<br />
			Postadresse: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spanien.
		</p>`
	},
	privacyPolicy: {
		lastUpdate: 'Sidst opdateret: 10. juni 2024',
		content: `
			<h3>1. Ansvarlig part og beskrivelse</h3>
			<h5>1.1. Ansvarlig</h5>
			<p>Den person, der er ansvarlig for behandlingen af dette websted, er Remove Background S.L (herefter benævnt Remove Background). 
			eller tjenesten), med adresse på Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spanien.</p>
			<p>NIF: B56768260<br> E-mail: {supportLink}</p>

			<h5>1.2. Beskrivelse</h5>
			<p>Accept af fortrolighedspolitikken for Remove Background (herefter "Privatlivspolitik") er en nødvendig betingelse 
				til brugen af vores hjemmeside og leveringen af tjenesten (i det følgende benævnt "tjenesten").<br>
				Denne privatlivspolitik regulerer indsamling, behandling og brug af dine personlige og ikke-personlige oplysninger 
				som bruger af Fjern baggrund, fra den ikrafttrædelsesdato, der vises i overskriften.<br>
				For at behandle dine personlige data overholder Remove Background gældende lokal og europæisk lovgivning, 
				samt dens gennemførelsesbestemmelser.</p>


			<h3>2. Oplysninger indsamlet</h3>
			<p>Adgang til vores hjemmeside kan ske uden behov for at give nogen oplysninger, men for at registrere og/ 
				eller aftale vores planer, skal du give os nogle personlige oplysninger. Oplysningerne (personlige 
				eller ikke-personligt) indsamlet af Tjenesten kan variere baseret på det.<br>
				De personlige og ikke-personlige oplysninger, der indsamles af Tjenesten, kommer til os på tre måder: 1) det, der 
				indsamles automatisk 2) det, du giver os frivilligt, og 3) det, der leveres af tredjeparter.</p>

			<h5>2.1. Den, der indsamles automatisk</h5>
			<p>Denne information vil bestå af:</p>
			<ul>
				<li>Den, der indsamles gennem cookies eller lignende mekanismer, der er gemt på din enhed, altid med dit samtykke eller i 
					i overensstemmelse med andre retsgrundlag. Se vores Cookiepolitik for at få flere oplysninger.</li>
				<li>Den IP, hvorfra forbindelsen er oprettet, den anvendte type enhed og dens karakteristika, versionen af 
					operativsystemet, typen af browser, sproget, datoen, landet, tidspunktet for anmodningen, 
					URL'en fra den, du kommer fra, den URL, du går til, eller det anvendte mobilnetværk, blandt andet.</li>
				<li>Tjenestebrugsdata og mulige fejl opdaget under brugen.</li>
				<li>Derudover bruger Remove Background Google Analytics, en analytisk tjeneste leveret af Google, LLC. 
					hjemmehørende i USA med hovedkvarter på 1600 Amphitheatre Parkway, Mountain View, Californien 94043. 
					Til levering af disse tjenester bruger de cookies, der indsamler oplysninger, herunder brugerens IP-adresse, 
					som vil blive transmitteret, behandlet og gemt af Google i de vilkår, der er fastsat på internettet www.google.com. 
					Herunder eventuel overførsel af nævnte oplysninger til tredjeparter af hensyn til lovkrav eller 
					når nævnte tredjeparter behandler oplysningerne på vegne af Google.</li>
			</ul>
			<p>Under alle omstændigheder kan du deaktivere Google Analytics-cookies fra <a href="{externalLink: disableGoogleAnalyticsLink}">her</a>.</p>

			<h5>2.2. Den du frivilligt giver</h5>
			<p>Denne information vil bestå af:</p>
			<ul>
				<li>Alle data er obligatoriske.</li>
				<li>Den, der kræves af Remove Background for at fuldføre din registrering på nettet: blandt andet navn og efternavn, adresse og e-mail.</li>
				<li>Alle data er obligatoriske.</li>
				<li>Oplysningerne, personlige eller ej, for at fuldføre kontrakten om tjenesten, såsom din e-mailadresse og dit kredit- eller betalingskortnummer.</li>
				<li>De oplysninger, personlige eller ej, som meddelelserne sendt gennem kontakt- eller meningskanalerne etableret i tjenesten kan indeholde, 
					for eksempel dit navn og din e-mailadresse.</li>
			</ul>

			<h5>2.3. Den, der leveres af tredjeparter</h5>
			<p>Denne information vil bestå af:</p>
			<ul>
				<li>Den, der leveres af betalingssystemer eller kreditkortbehandlere, såsom købstidspunktet eller dets beløb.</li>
			</ul>


			<h3>3. Rettigheder og formål</h3>
			<p>Vi informerer dig om, at udfyldelsen af formularerne er frivillig. Men hvis du ikke udfylder de påkrævede felter 
				(normalt markeret med en stjerne), vil brugen af nogle funktioner i Tjenesten ikke være mulig eller vil være begrænset.<br>
				De personlige data, som du giver os, vil blive inkorporeret og behandlet i Registry of Treatment Activities of Remove Background 
				for at kunne imødekomme dine anmodninger, levere den ønskede service og holde dig orienteret om forhold relateret til aktiviteten 
				af virksomheden og dens tjenester.<br>
				Du kan til enhver tid udøve retten til adgang, berigtigelse, sletning, begrænsning af din behandling, 
				modstand og portabilitet af dine personlige data via e-mail adresseret til: {supportLink} eller postadressen: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spanien.<br>
				I begge tilfælde skal du identificere dig med dit navn og efternavn, samt en kopi af dit DNI eller nationalt ID, hvis det er nødvendigt.<br>
				I tilfælde af at du har givet samtykke til et bestemt formål, har du til enhver tid ret til at trække samtykket tilbage, 
				uden at det påvirker lovligheden af behandlingen baseret på samtykket før dets tilbagetrækning.<br>
				Hvis du desuden mener, at der er et problem med måden, hvorpå Remove Background håndterer dine data, 
				du kan rette dine klager til den tilsvarende <a href="{knowYourRightsLink}">databeskyttelsesmyndighed</a>, som er <a href="{aepdLink}">det spanske agentur for databeskyttelse</a> 
				den, der er angivet i tilfældet Spanien.</p>


			<h3>4. Alder</h3>
			<p>Med hensyn til brugen af onlinetjenesten erklærer du, at du er myndig, og at du har den nødvendige juridiske 
				kapacitet til at være bundet af denne aftale og bruge webstedet i overensstemmelse med dets vilkår og betingelser, som du fuldt ud 
				forstå og anerkende.<br>
				Du erklærer, at alle de oplysninger, du giver for at få adgang til Tjenesten, før og under dens brug, er sande, fuldstændige 
				og præcis.</p>


			<h3>5. Brug af data</h3>
			<p>Fjern baggrund vil bruge de indsamlede data til at:</p>
			<ul>
				<li>Administrer og opdatere tjenesten (det juridiske grundlag er vores legitime interesse i at vedligeholde og beholde tjenesten 
					opdateret og i god stand).</li>
				<li>Tag de spørgsmål, du rejser (det juridiske grundlag er vores legitime interesse i at imødekomme anmodningerne og 
					vores brugeres tvivl).</li>
				<li>Behandle de betalinger, du foretager (kontrakten er det juridiske grundlag).</li>
				<li>Lever den aftalte service (kontrakten er det juridiske grundlag).</li>
				<li>Oprethold tjenestens sikkerhed, undersøg ulovlige aktiviteter, håndhæv vores vilkår og betingelser og
					hjælpe de statslige sikkerhedsstyrker inden for rammerne af deres mulige undersøgelser (det juridiske grundlag er vores 
					legitim interesse i at garantere og opretholde sikkerheden for Tjenesten og dens brugere).</li>
			</ul>
			<p>Fjern baggrund bruger ikke automatiserede beslutninger, selvom det kan generere grundlæggende brugerprofiler, 
				det juridiske grundlag er vores legitime interesse i kommercielle formål og at levere personlige tilbud.<br>
				Fjern baggrund kan også bruge brugeroplysninger i form af aggregerede og anonyme data til at vise dem til tredjeparter. 
				Du kan også dele statistik og demografiske oplysninger om brugere og deres brug af tjenesten med tredjeparter. 
				Men intet af dette vil tillade disse tredjeparter at identificere dig personligt.</p>

			<h5>5.1. I e-mails og kontaktformularer</h5>
			<p>Webstedet har en SSL-kryptering, der giver brugeren mulighed for at sende sine personlige data sikkert gennem standard kontaktformularer.<br>
				De indsamlede personoplysninger vil blive genstand for automatiseret behandling og indarbejdet i de tilsvarende filer 
				af registreringen af behandlingsaktiviteter, og som Remove Background er ejer af.</p>
			<p>I den forstand:</p>
			<ul>
				<li>Vi modtager din IP-adresse, som vil blive brugt til at bekræfte meddelelsens oprindelse for at tilbyde dig tilstrækkelig 
					anbefalinger (for eksempel præsentere oplysningerne på det korrekte sprog) og for at opdage mulige uregelmæssigheder 
					(f.eks. mulige forsøg på cyberangreb på tjenesten) samt data relateret til din internetudbyder.</li>
				<li>På samme måde kan du give os dine data via telefon, e-mail og andre angivne kommunikationsmidler.</li>
			</ul>
			<p>Angående det anvendte betalingsmiddel:</p>
			<ul>
				<li>Vores betalingstjenesteudbydere til at betale for leveringen af vores tjenester er kredit- eller betalingskort. 
					Tjenesten eller dens personale vil på intet tidspunkt have adgang til bankoplysningerne (f.eks. kreditkortnummeret) 
					som brugeren som kunde vil give til disse tredjeparter.</li>
			</ul>

			<h3>6. Dataopbevaring</h3>
			<p>Nedenfor er de angivet, hvor længe de data, der behandles af Tjenesten, opbevares:</p>
			<ul>
				<li>De opdelte data vil blive opbevaret uden en sletningsperiode.</li>
				<li>
					Kundedata vil blive opbevaret i det mindste nødvendige og kan opbevares indtil:
					<ul>
						<li>5 år i henhold til art. 1964 i Civil Code (personlige handlinger uden særlig frist).</li>
						<li>6 år i henhold til art. 30 i handelsloven (f.eks. regnskabsbøger eller fakturaer).</li>
					</ul>
				</li>
				<li>Brugerdata vil blive opbevaret i en periode på højst 12 måneder for at kunne imødekomme deres anmodninger.</li>
			</ul>


			<h3>7. Data deles med tredjeparter</h3>
			<p>Der er tredjeparter, der administrerer en del af tjenesten.<br>
				Fjern baggrund kræver, at de overholder denne privatlivspolitik som relevant, ud over at have deres egen. Fjern baggrund er dog ikke ansvarlig for overholdelse af nævnte politik.<br>
				Under nogle omstændigheder kan Remove Background dele, bruge eller bevare enhver af de indsamlede personlige oplysninger med tredjeparter:</p>
			<ul>
				<li>For at levere tjenesten:</li>
			</ul>
			<p>Tjenesteudbydere, der udfører funktioner på vores vegne, såsom betalingstjenester, webhosting, forretningsanalyse, kundeservice eller webmarketing. Disse tjenesteudbydere kan indsamle og have adgang til de oplysninger, der er nødvendige for, at de kan udføre deres funktioner, men de må ikke dele eller bruge oplysningerne til andre formål.</p>
			<ul>
				<li>For at samarbejde med de kompetente myndigheder:</li>
			</ul>
			<p>Hvis vi mener, at det med rimelighed er nødvendigt for at opfylde enhver lov, juridisk proces eller legitim interesse. Under alle omstændigheder vil vi kun give de strengt nødvendige oplysninger.</p>


			<h3>8. Sikkerhedsforanstaltninger</h3>
			<p>Fjern baggrund vedtager alle de tekniske og organisatoriske foranstaltninger, der er nødvendige for at
				beskytte sikkerheden og integriteten af personlige og ikke-personlige oplysninger, der indsamles. 
				Både mod uautoriseret adgang og dens utilsigtede ændring, tab eller ødelæggelse.<br>
				Under alle omstændigheder kan Remove Background ikke garantere den absolutte sikkerhed af de indsamlede oplysninger, 
				så du skal samarbejde og bruge sund fornuft om de oplysninger, der deles til enhver tid.<br>
				Du forstår og anerkender, at selv efter sletning kan personlige og ikke-personlige oplysninger evt 
				forblive synlig i cachen, eller hvis andre brugere har kopieret eller gemt den.</p>


			<h3>9. Ændringer i privatlivspolitikken</h3>
			<p>Vi opdaterer muligvis denne privatlivspolitik i fremtiden. Vi vil informere dig om ændringerne ved at sende en meddelelse til den angivne e-mailadresse og/eller ved at placere en meddelelse på et fremtrædende sted på vores hjemmeside.</p>


			<h3>10. Kontakt</h3>
			<p>Hvis du har spørgsmål om denne privatlivspolitik, så kontakt os på:</p>
			<p>E-mail: {supportLink}<br> 
				Adresse: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spanien.</p>
		`
	},
	gdpr: {
		lastUpdate: 'Sidst opdateret: 10. juni 2024',
		content: `
			<h3>1. Hvem er ansvarlig, og hvordan kontakter man dem?</h3>
			<p>Administratoren af dette websted er Remove Background S.L med adresse på Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spanien.</p>
			<p>Du kan kontakte ham via e-mail på {supportLink}.</p>

			<h3>2. Hvilke data indsamles?</h3>
			<p>
				Vi indsamler automatisk data gennem de cookies, som vi indlæser på din enhed, inklusive analyser. 
				Vi indsamler også den IP, hvorfra forbindelsen er lavet, den anvendte type enhed og dens karakteristika, 
				versionen af operativsystemet, typen af browser, sproget, datoen, landet, tidspunktet for anmodningen, 
				URL'en, du kommer fra, URL'en, du går til eller det anvendte mobilnetværk, blandt andet.<br>
				Frivilligt giver brugeren os nogle oplysninger såsom hans navn og efternavn, e-mail eller bankoplysninger 
				for at kunne kontakte os, tilmelde dig tjenesten eller købe et abonnement.
			</p>

			<h3>3. Hvad bruges de indsamlede data til?</h3>
			<p>
				Tjenesten vil blandt andet bruge de indsamlede data til at administrere og opdatere tjenesten, svare på dine anmodninger, 
				sende dig vores nyhedsbrev og kampagnetilbud via e-mail, administrere din registrering på platformen, administrere og levere 
				tjenesterne relateret til dit abonnement, behandle de betalinger, du foretager, og udstede de tilsvarende fakturaer, 
				opretholde tjenestens sikkerhed, efterforske ulovlige aktiviteter, håndhæve vores vilkår og betingelser og 
				hjælpe de statslige sikkerhedsstyrker og -organer inden for rammerne af deres eventuelle efterforskninger.
			</p>

			<h3>4. Hvor længe opbevares de?</h3>
			<ul>
				<li>De opdelte data vil blive opbevaret uden en sletningsperiode.</li>
				<li>
					Kundedata vil blive opbevaret i det mindste nødvendige og kan opbevares indtil:
					<ul>
						<li>5 år i henhold til art. 1964 i Civil Code (personlige handlinger uden særlig frist).</li>
						<li>6 år i henhold til art. 30 i handelsloven (f.eks. regnskabsbøger eller faktura).</li>
					</ul>
				</li>
				<li>Brugerdata vil blive opbevaret i en periode på højst 12 måneder for at imødekomme deres anmodninger.</li>
				<li>Brugerdata uploadet af Tjenesten til sider og profiler på sociale netværk vil blive opbevaret fra det øjeblik, brugeren giver sit samtykke, indtil han trækker det tilbage.</li>
			</ul>

			<h3>5. Hvad er dine rettigheder som bruger?</h3>

			<p>
				Ret til indsigt: Den berørte part har ret til at få bekræftelse fra den dataansvarlige om, hvorvidt 
				eller ikke behandles personoplysninger om ham eller hende.
			</p>
			<p>
				Ret til berigtigelse: Den berørte part skal have ret til uden unødig forsinkelse at indhente oplysninger fra den dataansvarlige 
				berigtigelse af personoplysninger, der er unøjagtige, og som berører ham direkte. Ligeledes vil den interesserede 
				har ret til at udfylde ufuldstændige personoplysninger, herunder ved hjælp af en tillægserklæring.
			</p>
			<p>
				Sletningsret: Det er den berørte parts ret til uden unødig forsinkelse at indhente sletningen fra den dataansvarlige 
				af de personoplysninger, der vedrører ham.
			</p>
			<p>
				Ret til at begrænse databehandling: består i at opnå begrænsning af behandlingen af dine data af den ansvarlige, 
				selv om dens udøvelse har to aspekter: 1) Når du udfordrer nøjagtigheden af dine personlige data, i en periode, der tillader 
				den ansvarlige til at verificere det og 2) Når du har gjort indsigelse mod behandlingen af dine personoplysninger, at den ansvarlige person 
				udfører ud fra legitim interesse eller en mission af offentlig interesse, mens den ansvarlige kontrollerer, om disse grunde 
				sejre over din.
			</p>
			<p>
				Ret til dataportabilitet: Det er den berørte parts ret til at modtage de personoplysninger, der vedrører ham, 
				som han har givet til en dataansvarlig, i et struktureret format, til almindelig brug og mekanisk læsning, og 
				at sende dem til en anden controller uden at blive forhindret af den controller, som de blev leveret til.
			</p>
			<p>
				I denne forstand vil den interesserede part have ret til at få personoplysninger overført direkte fra den dataansvarlige 
				til controller, når det er teknisk muligt.
			</p>

			<h3>6. Hvordan kan du udøve dine rettigheder?</h3>

			<p>
				Du kan til enhver tid udøve dine persondatarettigheder ved at sende en e-mail til: {supportLink} Eller postadressen: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spanien. I begge tilfælde skal du identificere dig med dit navn og efternavne, 
				samt en kopi af dit DNI eller nationale ID, hvis det er nødvendigt.<br>
				Hvis du desuden mener, at der er et problem med måden Remove Background håndterer dine data på, kan du rette dine krav 
				til <a href="{knowYourRightsLink}">databeskyttelsesmyndigheden</a>, der svarer, som er <a href="{aepdLink}">det spanske agentur for databeskyttelse</a> 
				den, der er angivet i tilfældet Spanien.
			</p>

			<h3>7. Er sikkerhedsforanstaltninger vedtaget?</h3>
			<p>
				Tjenesten tager alle nødvendige tekniske og organisatoriske foranstaltninger for at beskytte personlighedens sikkerhed og integritet 
				og ikke-personlige oplysninger indsamlet. Både mod uautoriseret adgang og utilsigtet ændring, tab eller ødelæggelse.<br>
				Under alle omstændigheder kan Tjenesten ikke garantere den absolutte sikkerhed af de indsamlede oplysninger, så du skal samarbejde og 
				brug sund fornuft til enhver tid med hensyn til delt information.<br>
				Du forstår og anerkender, at selv efter sletning, kan personlige og ikke-personlige oplysninger forblive synlige i cache eller 
				hvis de kopieres eller gemmes af andre brugere.
			</p>

			<h3>8. Er der overførsler af personoplysninger eller internationale overførsler?</h3>

			<p>
				Vi overfører ikke data eller internationale overførsler. Der er dog tredjeparter, der administrerer en del af Tjenesten 
				at vi kræver at overholde vores privatlivspolitik i det omfang den er gældende for dem, og at de har deres egen. 
				Disse tredjeparter er tjenesteudbydere, der udfører funktioner på vores vegne, såsom webhosting, 
				analyseovervågning eller webudvikling.<br>
				Også hvis vi mener, at det med rimelighed er nødvendigt for at opfylde enhver lov, juridisk proces eller legitim interesse. 
				Under alle omstændigheder vil vi kun give de strengt krævede oplysninger.
			</p>
		`
	},
	cookiesPolicy: {
		lastUpdate: 'Sidst opdateret: 21. juni 2024',
		content: `
			<h3>Oversigt</h3>
			<ul>
			    <li>Anvendte cookies: <strong>Egen og tredjepart</strong></li>
			    <li>Bruges de til at få statistik? <strong>Ja, baseret på vores legitime interesse i bedre at administrere tjenesten.</strong></li>
			    <li>Tredjepartstjenester, der installerer cookies via denne hjemmeside: <strong>Google, Google Analytics, Cloudflare og Stripe.</strong></li>
			</ul>

			<h3>Sådan konfigurerer og deaktiverer du cookies</h3>
			<p>
			    Du kan tillade, blokere eller slette de cookies, der er installeret på din enhed fra din webbrowser. Hvis du ikke tillader, at der installeres cookies på din enhed, 
			    browseroplevelsen kan blive værre. Nedenfor kan du finde, hvordan du konfigurerer cookies i hver browser:
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">Kant</a></li>
			    <li><a href="{externalLink: chromeCookies}">Google Chrome</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
			    <li><a href="{externalLink: operaCookies}">Opera</a></li>
			    <li><a href="{externalLink: safariCookies}">Safari</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">Safari Mobile</a></li>
			</ul>

			<h3>1. Typer og anvendelser</h3>
			<p>Tjenesten bruger egne og tredjepartscookies til at forbedre browsing, levere tjenesten og indhente statistik om brugen af hjemmesiden.</p>

			<h3>2. Hvad er en cookie, og hvad bruges den til?</h3>
			<p>
			    En cookie er en tekstfil, der sendes til din computer, mobil eller tablets webbrowser og bruges til at gemme og hente oplysninger om
			    browsingen udført. For eksempel for at huske dit brugernavn og adgangskode eller dine profilpræferencer.
			</p>

			<h3>3. Hvilke typer cookies findes der?</h3>
			<p>Ifølge hvem der administrerer dem:</p>
			<ul>
			    <li>Egne cookies; de sendes til din browser fra vores eget udstyr eller webdomæner.</li>
			    <li>Tredjepartscookies; de sendes til din browser fra udstyr eller webdomæner, som vi ikke administrerer direkte, men af en tredje enhed såsom Google.</li>
			</ul>
			<p>Baseret på, hvor længe de forbliver aktive, er der:</p>
			<ul>
			    <li>Sessionscookies; de forbliver i din browsers cookie-fil, indtil du forlader webstedet, så ingen bliver på din enhed.</li>
			    <li>Vedholdende cookies; de forbliver på din enhed, og vores hjemmeside læser dem, hver gang du foretager et nyt besøg. Disse cookies holder op med at virke efter en bestemt dato.</li>
			</ul>
			<p>Endelig, i henhold til deres formål, har vi:</p>
			<ul>
			    <li>Tekniske cookies; de forbedrer browsing og den korrekte funktion af webstedet.</li>
			    <li>Personlige cookies; de giver adgang til tjenesten med foruddefinerede karakteristika baseret på en række kriterier.</li>
			    <li>Analytics-cookies; de tillader måling og statistisk analyse af brugen af den leverede tjeneste.</li>
			</ul>
			<p>Liste over tredjepartscookies brugt af <strong>remove-background.com</strong></p>
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">Google</a>: Deres cookies (NID eller SAMTYKKE) gør det muligt at tilpasse, hvordan annoncer vises uden for Google eller gemme oplysninger
			        såsom det foretrukne sprog ved visning af søgeresultater.<br><a href="{externalLink: googleCookieTypes}">Flere oplysninger</a> om de typer cookies, som Google bruger i sine forskellige tjenester.
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">Google Analytics</a>: Deres cookies (såsom _ga) gør det muligt at tælle, hvor mange gange en bruger besøger et websted, hvordan, hvornår og hvorfra.<br>
			        Under alle omstændigheder kan du deaktivere Google Analytics-cookies fra <a href="{externalLink: disableGoogleAnalytics}">her</a>.
			    </li>
			    <li>Cloudflare: For at lære om Cloudflares cookiepolitik og brug, skal du klikke på <a href="{externalLink: cloudflareCookiesPolicy}">dette link</a>.</li>
			    <li>Stripe: Find information <a href="{externalLink: stripeCookiesPolicy}">her</a> om Stripes cookiepolitik og brug.</li>
			</ul>
		`
	}
};
